




import { Component, Mixins, Prop } from "vue-property-decorator";
import { IKeyHandleable } from "./IKeyHandleable";

@Component
export default class SelectAllKeyHandler extends Mixins() implements IKeyHandleable {
  @Prop()
  allSelected: () => boolean;

  handleKeyDowned(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if (!event.ctrlKey || (event.key !== "a")) {
      return false;
    }
    if (isInputting) {
      return false;
    }
    return !!this.allSelected
        && this.allSelected();
  }

  handleKeyUpped(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    return false;
  }
}
